import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { IMemberToastProps } from '../HBToast.types';
import MemberToast from './MemberToast';
import { HBButtonCustomTheme } from '../../HBButton/HBButton.types';

interface Props {
    toasts: IMemberToastProps[];
    removeItem: (id: string) => void;
    buttonTheme: HBButtonCustomTheme;
}

const MemberToastManager = ({ toasts, removeItem, buttonTheme }: Props) => {
    const sortedToasts = toasts.slice().sort((a, b) => {
        if (a.isPrioritized && !b.isPrioritized) {
            return -1;
        } else if (!a.isPrioritized && b.isPrioritized) {
            return 1;
        } else {
            return 0;
        }
    });

    return (
        <AnimatePresence>
            {sortedToasts.map((toast, idx) => (
                <MemberToast
                    key={toast.id}
                    {...toast}
                    isFirstInQueue={idx === 0}
                    removeItem={removeItem}
                    buttonTheme={buttonTheme}
                />
            ))}
        </AnimatePresence>
    );
};

export default MemberToastManager;
